import styled from "styled-components";
export const CpatchaContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Canvas = styled.div`
  display: flex;
  height: 38px;
  margin-right: 10px;
  border: 1px solid lightgray;
  border-radius: 10px;
  canvas {
    border-radius: 10px;
    cursor: pointer;
  }
`;
